import { Route } from '@/app/router'

const Shipments = () => import('./index.vue')
const ShipmentProps = ['page', 'perPage']


const ShipmentsMeta = {
	sort: 12,
	displayInSidebar: true,
	displayName: 'shipment',
	icon: 'fal box-open',
	activeIcon: 'fas box-open'
}

export default new Route('/shipments', Shipments)
	.as('Dashboard:Shipments')
	.props(ShipmentProps)
	.meta(ShipmentsMeta)
	.permissions(['VIEW_SHIPMENT'])
